import { useCallback, useContext } from 'react';
import { SettingsContext } from '../contexts/SettingsContext';

const useImageCompression = () => {
  const {selectedImageSize, selectedQuality} = useContext(SettingsContext);

  /*  console.log(selectedImageSize, selectedQuality) */
  const compressImage = useCallback(
    (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            let width = img.width;
            let height = img.height;

            if (width > height && width > selectedImageSize) {
              height = Math.round(height * (selectedImageSize / width));
              width = selectedImageSize;
            } else if (height > selectedImageSize) {
              width = Math.round(width * (selectedImageSize / height));
              height = selectedImageSize;
            }

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
              (blob) => {
                if (!blob) {
                  return reject(new Error('Ошибка при сжатии изображения'));
                }
                resolve(
                  new File([blob], file.name, {
                    type: 'image/jpeg',
                    lastModified: Date.now(),
                  })
                );
              },
              'image/jpeg',
              selectedQuality
            );
          };
          img.onerror = () => reject(new Error('Ошибка загрузки изображения'));
        };
        reader.onerror = () => reject(new Error('Ошибка чтения файла'));
      });
    },
    [selectedImageSize, selectedQuality]
  );

  return {compressImage};
};

export default useImageCompression;
